export default __webpack_public_path__ + "static/media/003-alarm.ed866632.svg";